<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  watch:{
    '$route':function(to,from){
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    }
  }
};
</script>

<style>
body {
  margin: 0;
  padding: 0;
  min-width: 1440px;
  overflow-x: auto;
}
a {
  text-decoration: none;
}
.header .lang-img {
  width: 34px;
  cursor: pointer;
  margin-left: 20px;
}
.tabLanguage {
  font-size: 14px;
  color: #333333;
}
</style>



// WEBPACK FOOTER //
// src/App.vue